import { APP_ROUTES } from "../../../constants";
import { AppRouteMenuModel } from "../../../models";
import { BannerList, FocusedMarketList, SolutionList, NetworkList, CareerListing } from "..";

export const PageManagementRoutes: AppRouteMenuModel[] = [
  {
    // Banners
    path: APP_ROUTES.PAGEMANAGEMENT.BANNER.BASE,
    title: "Banners",
    renderComponent: () => {
      return <BannerList />;
    },
  },
  {
    // Our Solutions
    path: APP_ROUTES.PAGEMANAGEMENT.SOLUTION.BASE,
    title: "Our Solutions",
    renderComponent: () => {
      return <SolutionList />;
    },
  },
  {
    // Focused Market
    path: APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.BASE,
    title: "Focused Market",
    renderComponent: () => {
      return <FocusedMarketList/>
    },
  },
  {
    // Network
    path: APP_ROUTES.PAGEMANAGEMENT.NETWORK.BASE,
    title: "Network",
    renderComponent: () => {
      return <NetworkList />;
    },
  },
  {
    // Careers
    path: APP_ROUTES.PAGEMANAGEMENT.CAREER.BASE,
    title: "Careers",
    renderComponent: () => {
      return <CareerListing />;
    },
  },
];
